/**
 * Tell if we are on production
 * @param env
 */
export const isProduction = (env = process.env.REACT_APP_BUILD_ENV): env is "production" => {
  return env === "production";
};
